(function() {
  'use strict';
  angular.module('blocks.issueMonitoring', []);
})();
